import { Component, inject } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'

@Component({
    selector: 'app-warning',
    templateUrl: './warning.component.html',
    styleUrls: ['./warning.component.css'],
    standalone: false
})
export class WarningComponent {
    private dialogRef = inject<MatDialogRef<WarningComponent>>(MatDialogRef);

    description: string
    headerText: string
    doneText: string

    constructor() {
        const data = inject(MAT_DIALOG_DATA);

        this.description = data.description || ''
        this.headerText = data.headerText || ''
        this.doneText = data.doneText || 'OK'
    }

    onDone() {
        this.dialogRef.close()
    }
}
